"use client";

import { VariantProps, cva } from "class-variance-authority";
import { useState, useEffect, useRef } from "react";
import {
  Input,
  Label,
  SearchField as AriaSearchField,
  Group,
} from "react-aria-components";
import { Spinner } from "ui-components";

interface IChatBoxSearchFieldProps
  extends VariantProps<typeof SearchFieldInputClass> {
  label?: string;
  placeholder?: string;
  isLoading?: boolean;
  onChange?: (value: string) => void;
  className?: string;
  isSearchButtonVisible?: boolean;
}

export function ChatBoxSearchField({
  label,
  placeholder,
  isLoading = false,
  onChange,
  className,
}: Readonly<IChatBoxSearchFieldProps>): JSX.Element {
  const [searchTerm, setSearchTerm] = useState<string>("");
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      onChange?.(searchTerm);
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [searchTerm]);

  return (
    <AriaSearchField className={SearchFieldWrapperClass({})}>
      <Label>{label}</Label>
      <Group
        className={SearchFieldInputClass({
          className,
        })}
      >
        <Input
          autoFocus
          className="outline-none flex w-full mr-5"
          ref={inputRef}
          placeholder={placeholder}
          value={searchTerm}
          onChange={({ target }) => setSearchTerm(target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.currentTarget.blur(); // This will remove focus from the input when Enter is pressed
            }
          }}
        />
        {isLoading && (
          <span className="mr-2.5">
            <Spinner />
          </span>
        )}
      </Group>
    </AriaSearchField>
  );
}

const SearchFieldWrapperClass = cva(
  "w-full flex flex-col justify-start flex-1 "
);
const SearchFieldInputClass = cva(
  "flex flex-row justify-start items-center gap-2 outline-none ml-4"
);
